module.exports = __webpack_public_path__ + "img/medal-silver.db34c724.svg";